import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaTools, FaBolt, FaBuilding } from "react-icons/fa";

const ServicesSection = () => {
  const services = [
    {
      category: "Mechanical",
      icon: <FaTools />,
      items: [
        "Fitting",
        "HVAC and refrigeration",
        "Kitchen equipments",
        "Fire detection, production, and extinguishing",
      ],
    },
    {
      category: "Electrical",
      icon: <FaBolt />,
      items: ["Heavy current", "Light current"],
    },
    {
      category: "Civil",
      icon: <FaBuilding />,
      items: [
        "Brick laying and plastering",
        "Tiling and ceiling",
        "Plumbing",
        "Painting",
        "architectural designs and surveying",
        "Plumbing and pipe fitting",
      ],
    },
  ];

  return (
    <ServicesContainer id="services">
      <Content>
        <Title
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          Our Services
        </Title>
        <ServicesGrid>
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.2, ease: "easeOut" }}
            >
              <ServiceIcon>{service.icon}</ServiceIcon>
              <ServiceCategory>{service.category}</ServiceCategory>
              <ServiceList>
                {service.items.map((item, itemIndex) => (
                  <ServiceItem key={itemIndex}>{item}</ServiceItem>
                ))}
              </ServiceList>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </Content>
    </ServicesContainer>
  );
};

// Styled Components
const ServicesContainer = styled.section`
  background-color: #f3f6fb;
  color: #003366;
  padding: 80px 20px;
`;

const Content = styled.div`
  width: 80%; /* Restrict width to 80% */
  margin: auto; /* Center content horizontally */
  text-align: center;
`;

const Title = styled(motion.h2)`
  font-size: 2.5rem;
  margin-bottom: 40px;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const ServiceCard = styled(motion.div)`
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-10px);
  }
`;

const ServiceIcon = styled.div`
  font-size: 3rem;
  color: #ffa500;
  margin-bottom: 20px;
`;

const ServiceCategory = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #003366;
`;

const ServiceList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const ServiceItem = styled.li`
  font-size: 1rem;
  line-height: 1.5;
  color: #003366;

  &:before {
    content: "•";
    color: #ffa500;
    margin-right: 8px;
  }
`;

export default ServicesSection;
